export default function LoadingDots() {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', height: 14 }}>
      <span className="loading-dot" />
      <span className="loading-dot" />
      <span className="loading-dot" />
    </span>
  );
}
